export default __webpack_public_path__ + "static/media/historia.39a6af67.svg";